import styles from './ForgotPassword.module.scss';
import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { AppRoutes, AuthRoutes } from '../../../routes/routeConstants/appRoutes';
import { Button } from 'antd';
import InputField from '../../../shared/components/InputField';
import { InputFieldType } from '../../../enums/inputFieldTypes';
import { FieldLabels, FieldNames, forgotPasswordValidation } from './constants';
import Form from '../../../shared/components/Form';
import { ItemSize } from '../../../enums/sizeEnums';
import { InputStyle } from '../../../enums/inputEnums';
import { FieldValues } from 'react-hook-form';
import AuthService from '../../../services/AuthService/authService.service';
import { useMutation } from '@tanstack/react-query';
import { ButtonHtmlType } from '../../../enums/buttomEnums';
import ConditionalRender from '../../../shared/components/ConditionalRender';
import { useAuth } from '../../../context/AuthContext';

const ForgotPassword: React.FC = () => {
  const { authenticated: isAuthenticated } = useAuth();
  const { emailField } = FieldNames;
  const { EMAIL } = FieldLabels;
  const navigate = useNavigate();
  const { requestPasswordReset } = AuthService();
  const { mutate, isPending } = useMutation(requestPasswordReset());
  const [submittedEmail, setSubmittedEmail] = useState<boolean>(false);

  if (isAuthenticated) return <Navigate to={AppRoutes.HOME} replace />;

  const handleSubmitForm = (values: FieldValues) => {
    mutate({ email: values.email }, { onSuccess: () => setSubmittedEmail(true) });
  };

  const handleBackToLogin = () => {
    if (!isPending) navigate(AuthRoutes.LOGIN);
  };

  return (
    <div className={styles.centeredContainer}>
      <div className={styles.innerContainer}>
        <div>
          <div className={styles.header}>
            <img className={styles.backButton} onClick={handleBackToLogin} src={'/assets/back_button_circle.svg'} alt={'Click to return'} />
            <h1>PASSWORD RECOVERY</h1>
          </div>
        </div>
        <div className={styles.fieldsContainer}>
          <ConditionalRender
            visible={submittedEmail}
            fallback={
              <Form validationSchema={forgotPasswordValidation} onSubmit={handleSubmitForm}>
                {() => (
                  <>
                    <InputField
                      type={InputFieldType.TEXT}
                      name={emailField}
                      label={EMAIL}
                      inputStyle={InputStyle.LOGIN}
                      size={ItemSize.LARGE}
                      className={styles.emailInput}
                    />
                    <p className={styles.byLine}>Enter your email address, and we'll send you a password reset link.</p>
                    <Button className={styles.submitButton} size={ItemSize.LARGE} htmlType={ButtonHtmlType.Submit} loading={isPending}>
                      RESET PASSWORD
                    </Button>
                  </>
                )}
              </Form>
            }
          >
            <p className={styles.byLine}>If the email address exists in the system, you have been sent a password reset link.</p>
            <p className={styles.byLine}>Forgot your email or did not receive a link? Try again or contact us for help.</p>
            <Button className={styles.submitButton} size={ItemSize.LARGE} onClick={() => setSubmittedEmail(false)}>
              TRY AGAIN
            </Button>
          </ConditionalRender>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
